import InstanceClient from "../services/InstanceClient";
import StatusCode from "../util/StatusCode";
import { Action, Reducer } from "redux"
import { Dispatch } from "react"
import { OneRosterDashboard, ScheduleSyncDashboard, SchoolAdminDashboard } from "../models/CoreDashboardModels";
import { RequestState } from "../models/RequestState";


enum DashboardTypes {
    GET_SCHOOLADMIN_INFO = 'GET_FLOWSYNC_INFO',
    GET_SCHEDULESYNC_INFO = 'GET_SCHEDULESYNC_INFO',
    GET_ONEROSTER_INFO = 'GET_ONEROSTER_INFO'
}

export interface DashboardState {
    schoolAdmin: RequestState<SchoolAdminDashboard>
    scheduleSync: RequestState<ScheduleSyncDashboard>
    oneRoster: RequestState<OneRosterDashboard>
};

interface Dashboard_SchoolAdmin extends Action<DashboardTypes> {
    type: DashboardTypes.GET_SCHOOLADMIN_INFO,
    schoolAdmin: RequestState<SchoolAdminDashboard>
};

interface Dashboard_ScheduleSync extends Action<DashboardTypes> {
    type: DashboardTypes.GET_SCHEDULESYNC_INFO,
    scheduleSync: RequestState<ScheduleSyncDashboard>
};

interface Dashboard_OneRoster extends Action<DashboardTypes> {
    type: DashboardTypes.GET_ONEROSTER_INFO,
    oneRoster: RequestState<OneRosterDashboard>
}

type DashboardAction = Dashboard_SchoolAdmin | Dashboard_ScheduleSync | Dashboard_OneRoster;


export const GetSchoolAdminInfo = () => (dispatch: Dispatch<Dashboard_SchoolAdmin>) => {
    return InstanceClient.get<SchoolAdminDashboard>('/api/core/dashboard/schooladmin')
        .then(res =>
            dispatch({
                type: DashboardTypes.GET_SCHOOLADMIN_INFO,
                schoolAdmin: { code: StatusCode.COMPLETE, data: res.data }
            }))
        .catch(err =>
            dispatch({
                type: DashboardTypes.GET_SCHOOLADMIN_INFO,
                schoolAdmin: { code: StatusCode.ERROR, error: err }
            }));
};

export const GetScheduleSyncInfo = () => (dispatch: Dispatch<Dashboard_ScheduleSync> ) => {
    return InstanceClient.get<ScheduleSyncDashboard>('/api/core/dashboard/schedulesync')
        .then(res =>
            dispatch({
                type: DashboardTypes.GET_SCHEDULESYNC_INFO,
                scheduleSync: { code: StatusCode.COMPLETE, data: res.data }
            }))
        .catch(err =>
            dispatch({
                type: DashboardTypes.GET_SCHEDULESYNC_INFO,
                scheduleSync: { code: StatusCode.ERROR, error: err }
            }));
};

export const GetOneRosterInfo = () => (dispatch: Dispatch<Dashboard_OneRoster>) => {
    return InstanceClient.get<OneRosterDashboard>('/api/core/dashboard/oneroster')
        .then(res =>
            dispatch({
                type: DashboardTypes.GET_ONEROSTER_INFO,
                oneRoster: { code: StatusCode.COMPLETE, data: res.data }
            }))
        .catch(err =>
            dispatch({
                type: DashboardTypes.GET_ONEROSTER_INFO,
                oneRoster: { code: StatusCode.ERROR, error: err }
            }));
};

const initialState: DashboardState = {
    schoolAdmin: { code: StatusCode.PENDING },
    scheduleSync: { code: StatusCode.PENDING },
    oneRoster: { code: StatusCode.PENDING },
};

export const reducer: Reducer<DashboardState, DashboardAction> = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case DashboardTypes.GET_SCHOOLADMIN_INFO:
            return {
                ...state,
                schoolAdmin: action.schoolAdmin,
            };
        case DashboardTypes.GET_SCHEDULESYNC_INFO:
            return {
                ...state,
                scheduleSync: action.scheduleSync,
            };
        case DashboardTypes.GET_ONEROSTER_INFO:
            return {
                ...state,
                oneRoster: action.oneRoster,
            };
        default:
            return state;
    }
};